module.exports = __webpack_public_path__ + "img/loginBG.3d1cad16.jpg";